import { useQuery } from "@tanstack/react-query";
import { laddersApi } from "../../api/ladders";
import { normalizeId, type MaybeId } from "./queryKeyUtils";

export const ladderKeys = {
  all: ["ladders"] as const,
  unofficial: () => ["ladders", "unofficial"] as const,
  detail: (id: MaybeId) => ["ladders", "detail", normalizeId(id)] as const,
  organizableByMe: () => ["ladders", "organizableByMe"] as const,
};

export const useUnofficialLadders = () =>
  useQuery({
    queryKey: ladderKeys.unofficial(),
    queryFn: laddersApi.listUnofficial,
  });

export const useLadderDetail = (id: MaybeId) =>
  useQuery({
    queryKey: ladderKeys.detail(id),
    queryFn: () => laddersApi.getDetail(id!),
    enabled: id != null,
  });

export const useOrganizableLadders = (enabled = true) =>
  useQuery({
    queryKey: ladderKeys.organizableByMe(),
    queryFn: laddersApi.listOrganizableByMe,
    enabled,
  });
